import { KeyboardEvent, ReactNode, useId, useRef } from 'react'

export interface Pestana {
  clave: string
  texto: ReactNode
}

/**
 * Pestañas del kit (`dcc-tabs`), con el teclado del patrón ARIA: flechas, Inicio y Fin
 * mueven y activan. El contenido de la pestaña activa va en `children`.
 */
export function Pestanas({
  etiqueta, pestanas, activa, onCambiar, children,
}: {
  etiqueta: string
  pestanas: Pestana[]
  activa: string
  onCambiar: (clave: string) => void
  children: ReactNode
}) {
  const id = useId()
  const botones = useRef<(HTMLButtonElement | null)[]>([])
  const indice = pestanas.findIndex((p) => p.clave === activa)

  const teclado = (e: KeyboardEvent) => {
    const n = pestanas.length
    const destino = { ArrowRight: indice + 1, ArrowLeft: indice - 1, Home: 0, End: n - 1 }[e.key]
    if (destino === undefined) return
    e.preventDefault()
    const i = ((destino % n) + n) % n
    onCambiar(pestanas[i].clave)
    botones.current[i]?.focus()
  }

  return (
    <div className="dcc-tabs">
      <div className="dcc-tabs__list" role="tablist" aria-label={etiqueta} onKeyDown={teclado}>
        {pestanas.map((p, i) => (
          <button
            key={p.clave}
            ref={(el) => {
              botones.current[i] = el
            }}
            type="button"
            role="tab"
            id={`${id}-${p.clave}`}
            className="dcc-tabs__tab"
            aria-selected={p.clave === activa}
            aria-controls={`${id}-panel`}
            tabIndex={p.clave === activa ? 0 : -1}
            onClick={() => onCambiar(p.clave)}
          >
            {p.texto}
          </button>
        ))}
      </div>
      <div className="dcc-tabs__panel" role="tabpanel" id={`${id}-panel`} aria-labelledby={`${id}-${activa}`}>
        {children}
      </div>
    </div>
  )
}
